import {useReversalService} from '../../service/reversal/index'

const useBatchSaveAddaForm = () => {
    const {saveMultiFaqsTable} = useReversalService()
  const updateMultiFaqTable = async (data: any) => {
     const res = await saveMultiFaqsTable(data)
     return res;
  };
  return {
    updateMultiFaqTable,
  };
};

export default useBatchSaveAddaForm;
